module.exports = "<div class=\"offset-field button-field\">\n\n    <button type=\"button\" mat-raised-button #input\n      color=\"accent\"\n      [disabled]=\"(locked || disabled || standard == null)\"\n      (click)=\"showInputDialog()\">\n      Offset\n    </button>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/forms/offset-field.component.html
// module id = ./src/app/forms/offset-field.component.html
// module chunks = main